module.exports = "<gw-bop-additional-coverages update-coverages=\"updateCoverages\"/>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gw-portals-policytransaction-renewal-bop-angular/additionalCoverages/additionalCoverages.html
// module id = 878
// module chunks = 0